import { Button } from "@/components/ui/button";
import IDENTIFIERS from "@/constants/test_id";
import type { ExtraData } from "@/types";
import { X } from "lucide-react";

// @ts-expect-error -- untyped module
const LoginSupportChatbotUrl = import.meta.env.VITE_LOGIN_SUPPORT_CHATBOT;

type LoginSupportChatbotProps = {
  onClose: () => void;
  rawUrlParams: ExtraData;
};

const LoginSupportChatbot: React.FunctionComponent<
  LoginSupportChatbotProps
> = ({ onClose, rawUrlParams }) => {
  const loginSupportChatbotUrl = `${LoginSupportChatbotUrl}?${new URLSearchParams(rawUrlParams).toString()}`;
  return (
    // 1.3.1 Info and Relationships — A: rendered inline inside the page's own <main>
    // (group.tsx), never on its own — a nested <main> is an invalid, duplicate landmark.
    <div className="flex size-full flex-col bg-gray-200">
      {/* 1.3.1 / 2.4.6 Headings and Labels — AA: gives this content an accessible name
          while it replaces the page — there was no heading anywhere in this component. */}
      <h1 className="sr-only">Login support</h1>
      <div className="relative flex flex-1 overflow-hidden">
        <Button
          variant="ghost"
          aria-label="Close"
          className="absolute right-2 top-5 size-fit cursor-pointer p-0 hover:bg-transparent"
          onClick={onClose}
          data-testid={IDENTIFIERS.GROUP_SCREEN.LOGIN_SUPPORT_CLOSE_BUTTON}
        >
          <X size={20} />
        </Button>
        {/* 4.1.2 Name, Role, Value — A / 1.1.1 — A: an <iframe> with no title is
            announced only as "iframe", with no indication of what it contains. */}
        <iframe
          src={loginSupportChatbotUrl}
          title="Login support chat"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default LoginSupportChatbot;
